//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Snackbar, Alert } from '@mui/material';
//  -- Components ---------------------
import BalconCover from "components/BalconCover";
import Loading from "components/Loading";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { AnecdotasThemes, APTHEME, CATEGORIAS, getFireBaseUrl, IBTHEME, INFORMATE_BASE64, Categorias } from "utils/config/reference";
import { useBookUnits } from "store/booksUnits/selectors";
import COLOR from "utils/constants/color";
import { handleListBookUnits } from "store/booksUnits/thunks";
import { useCurrentOrgPermission, useOrgTimezone } from 'store/organizations/selectors';
import { useAlertView } from "store/alert/selectors";
import { useDemoStatus } from "store/users/selectors";
import { Col, Row, Skeleton } from 'antd';
import { chunk, filter, map, get, find } from 'lodash';
import { isAfterTime } from "utils/methods/math";
import moment from "moment";
import DropdownMenu from "components/DropDowns/DropdownMenu";
import HeartIcon from "utils/assets/images/heart-icon.svg";
import BackIcon from "utils/assets/images/back-icon-resource.svg";
import ChampionIcon from "utils/assets/images/champion.svg";
import TaskIcon from "utils/assets/images/task-icon.svg";
import { handleCreateFavouriteVideo, handleListFavouriteVideo, handleListMostUsedEbookById } from "store/FavouriteVideo/thunks";
import { useFavouriteVideo } from "store/FavouriteVideo/selectors";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useFirebase } from "./FirebaseContext";
import { useResourceViews } from "utils/methods/firebaseResource";
import { EmptyImagePlaceholder } from "components/EmptyPlaceholderLesson";
import { BackButtonEbook } from "components/UI/buttons/Backbutton";
import RenderIfVisible from 'react-render-if-visible';
import { redirectToHome } from 'utils/config/navigation';
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
const CHAPTER_ID = '41'



//  -- Constants ----------------------

//  -- Features -----------------------

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-height: 90vh;
  justify-content: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  width: calc(100% + 48px);
  margin-left: -24px;
  padding: 0px 24px;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    padding: 0px 8px !important;
  }
`;
const Block = styled.div`
  min-height: 300px;
`;
// export const Wrapper = styled.div`
//     height: 100%;
//     width: 100%;
//     background-image:url(${BgImage})
// `;

const ListItem = styled.li`
  margin: 0px 16px 0px;
  width: calc(14% - 32px);

  @media only screen and (min-width: 600px) and (max-width: 800px) {
    margin: 0px 16px 32px;
    width: calc(50% - 32px);
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin: 0px 16px 32px;
    width: 100%;
  }
`;
const List = styled.ul`
  /* width: calc(100% + 40px); */
  /* width: calc(100% + -200px); */

  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  justify-content: center;
`;
//   margin-left: 12%;
// width: 75%;
const ListItemCovers = styled.li`
  margin: 0px 16px 32px;
  width: calc(16% - 25px);

  @media only screen and (min-width: 600px) and (max-width: 800px) {
    margin: 0px 16px 32px;
    width: calc(50% - 32px);
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin: 0px 16px 32px;
    width: 100%;
  }
`;
const ListCovers = styled.ul`
  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
`;
const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    padding:10px 0px;
    padding-bottom:20px;
     @media (max-width: 1366px) {
      display:none;
     }
`;
const BoxRow = styled.div`
    width: 100%;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 10px 20px;

    @media (max-width: 992px) {
      padding:5px;
    }
    @media (max-width: 768px) {
      // display: inherit;
    }
`;
const Column = styled.div`
  width:23%;
  cursor: pointer;
  margin: 10px;
  position:relative;
  @media (max-width: 768px) {
    width:32%;
      margin: 10px 5px;
  }

`;
const CoverSecion = styled.div`
  width:100%;
  height:100%;
  // overflow-y:${p => p.overflowItem ? "scroll" : "hidden"};
  @media (max-width: 768px) {
    padding-top:20px;
  }
`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const CategoryMenu = styled.div`
   background-color: #0b1c2b;
  border-radius: 30px;
  color: #fff;
  width: 300px;
  height: 42px;
  // margin-top: 20px;
  display: flex;
  align-items: center;
  // justify-content: center;
  // text-align: center;
  color: #fff;
  // font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #fff;
  color: #fff;
  padding-left: 15px;
  // padding-right: 15px;
  justify-content: space-between;
  // margin: 20px 10px;
  // margin: 20px 20px 20px 10px;

  @media screen and (max-width: 1200px) {
    font-size: 14px;
  }
  @media screen and (max-width: 576px) {
    // margin: 15px 8px;
`;
const MenuIconImg = styled.img`
    margin-left:10px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
`;
const SearchInput = styled.input`
     // width: 100px;
  // width: 80px;
  height: 100%;
  color: #fff;
  border: none;
  background: transparent;
  outline: none;
  // text-align: center;
  // font-weight: 800;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${COLOR.white};
  }
  ::focus {
    outline: none;
  }
  @media only screen and (max-width: 360px) {
    width: 92px;
  }
`;
const NewTag = styled.div`
    color:#fff;
    background-color:rgb(211,51,49);
    text-transform: uppercase;
    font-weight:800;
    font-weight: 800;
    width: 60px;
    position: absolute;
    text-align:center;
    top: -22px;
    @media (max-width: 600px) {
      top:-17px;
      font-size:11px;
      width:42px;
    }
`;

const CoverSkeleton = styled(Skeleton.Image)`
    width: 100% !important;
    height: 200px !important;
    @media (max-width: 768px) {
        height: 150px !important;
    }
`;

const SkeletonPlaceholder = styled.div`
    background-color: transparent;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    overflow: hidden;
`;

const SkeletonFooter = styled.div`
    background-color: #171E2D;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const filterWithTextVideos = (units, txt) => {
  const itemtext = txt.toLowerCase().trimStart().trimEnd()
  return filter(units, k => {
    if (get(k, 'categorias', "").toLowerCase().includes(itemtext) || get(k, 'tags', "").toLowerCase().includes(itemtext)) {
      return true;
    } else if (get(k, 'shortName', "").toLowerCase().includes(itemtext)) {
      return true;
    } else {
      return false;
    }
  })

}
const sortUnits = function (a, b) {
  if (Number(a.id) < Number(b.id)) {
    return 1;
  }
  if (Number(a.id) > Number(b.id)) {
    return -1;
  }
  // a must be equal to b
  return 0;
}
const InformateEbook = ({
  currentUser
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bookUnitList = useBookUnits()
  const [units, setUnits] = useState(get(find(bookUnitList, ["bookId", CHAPTER_ID]), "pages", []))
  const UNIT_PAGES = get(find(bookUnitList, ["bookId", CHAPTER_ID]), "pages", []).sort(sortUnits)
  const UNIT_IMAGE = get(find(bookUnitList, ["bookId", CHAPTER_ID]), "img", INFORMATE_BASE64)
  const [loading, setLoading] = useState(false);
  const [selectedCategoray, setSelectedCatogray] = useState('')
  const [categorias, setCategorais] = useState(Categorias)
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    type: 'error'
  });
  const timeZone = useOrgTimezone();
  const [mostUsedData, setMostUsedData] = useState([]);
  const [, invokeAlert, revokeALert] = useAlertView()
  const orgPermissions = useCurrentOrgPermission()
  const demoStatus = useDemoStatus()
  useEffect(() => {
    if (orgPermissions && typeof orgPermissions['1nformate'] === "boolean") {
      if (!orgPermissions['1nformate']) {
        invokeAlert()
        setTimeout(() => {
          navigate(redirectToHome(currentUser) || '-1');
          revokeALert()
        }, 5000)
      }
    }
  }, [orgPermissions])
  const showCopyRight = () => {
    setAlert({
      open: true,
      message: "Content is protected!",
      type: "error"
    })
  }
  const fetchData = async () => {
    const forUserLoaded = localStorage.getItem("forUser");
    if (forUserLoaded == currentUser?.id || forUserLoaded == "nouser") {
      setLoading(false);
    } else {
      if (Array.isArray(bookUnitList) && bookUnitList.length > 0) {
        setLoading(false);
      } else {
        setLoading(true);
      }
    }
    fetchFavorites()
    await dispatch(handleListBookUnits())
    setLoading(false);
    localStorage.setItem("forUser", currentUser?.id ?? "nouser");
  }

  const fetchMostUsedVideo = async () => {
    try {
      const arr = [];
      const data = await dispatch(handleListMostUsedEbookById(CHAPTER_ID));
      if (data) {
        arr.push(data);
        setMostUsedData(arr);
      }
    } catch (err) {
      Sentry.captureException(`413 Error during fetchMostUsedVideo: ${err}`);
      console.log(err)
    }
  }

  useEffect(() => {
    const fetchAllAPI = async () => {
      await Promise.all([fetchMostUsedVideo(), fetchData()])
      setIsFetchDataComplete(true);
    }
    fetchAllAPI();
  }, [])
  const showAdoption = () => {
    setAlert({
      open: true,
      message: "Coming soon!",
      type: "success"
    })
  }
  const handleClose = () => {
    setAlert({
      open: false,
      message: "",
      type: "error"
    })
  };
  const sortUnitsByNew = (res) => {
    const newUnits = filter(res, ["new", true]).sort(sortUnits)
    const oldUnits = filter(res, k => !k.new).sort(sortUnits)
    return [...newUnits, ...oldUnits]
  }
  useEffect(() => {
    const catrgotyForUnits = Array.from(new Set(map(UNIT_PAGES, k => k.categorias)))
    if (catrgotyForUnits.length > 0) {
      catrgotyForUnits.push("All")
      setCategorais(catrgotyForUnits)
    }
    setUnits(sortUnitsByNew(UNIT_PAGES))
  }, [bookUnitList])
  const filterByCategory = (cat) => {
    if (cat == '' || cat == 'All') {
      setUnits(sortUnitsByNew(UNIT_PAGES))
    } else {
      setUnits(sortUnitsByNew(filter(UNIT_PAGES, ['categorias', cat])))
    }
    setSelectedCatogray(cat)
  }
  const searchUnits = (text) => {
    if (!text || text.length < 2) {
      setUnits(sortUnitsByNew(UNIT_PAGES))
    } else {
      setUnits(sortUnitsByNew(filterWithTextVideos(UNIT_PAGES, text)))
    }
  }
  const categoryNav = () => {
    return {
      items: map(categorias, ct => ({
        key: ct,
        label: (
          <PaddedBtn onClick={() => {
            filterByCategory(ct)
          }}>
            {ct}
          </PaddedBtn>
        ),
        style: { padding: '0px' }
      }))
    };
  }
  const onPageClick = (item, i, index) => {
    const startDate = get(item, 'startDate');
    if (startDate) {
      if (isAfterTime(startDate, moment(), timeZone)) {
        showAdoption()
      } else {
        const url = `/informateBook?id=${item.id}&page=${item.start}&activity=null&quiz=null`
        navigate(url)
      }
    }
    else {
      const firstitem = i == 0 && index === 0
      if (demoStatus && !firstitem) {
        setAlert({
          open: true,
          message: "Restricted access (legend)",
          type: "error"
        })
        return;
      }
      const url = `/informateBook?id=${item.id}&page=${item.start}&activity=null&quiz=null`
      navigate(url)
    }
  }


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    document.body.classList.add("blue-bg-ebook");
    document.body.classList.add("overflow-x-hidden");

    return () => {
      document.body.classList.remove("overflow-x-hidden");
      document.body.classList.remove("blue-bg-ebook");
    };
  }, []);
  const [apThemeFilter, setApThemeFilter] = useState([]);
  const [ibThemeFilter, setIbThemeFilter] = useState([]);
  const [anecotasThemeFilter, setAnecotasThemeFilter] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [isDropdownOpen, setIsDropdownOpen] = useState({ type: "", open: false });
  const [searchQuery, setSearchQuery] = useState("");
  const [isSelectedFilter, setIsSelectedFilter] = useState("");
  const [loader, setLoader] = useState("");
  const allFavorites = useFavouriteVideo();
  const { firestore } = useFirebase()
  const { createResourceViews } = useResourceViews()
  const [fetchFavoritesList, setFetchFavorites] = useState(allFavorites);
  const [mostViewedLesson, setMostViewedLesson] = useState([]);
  const [isFetchDataComplete, setIsFetchDataComplete] = useState(false);


  useEffect(() => {
    if (isFetchDataComplete) {
      const createFavourite = async () => {
        await dispatch(handleCreateFavouriteVideo(fetchFavoritesList));
      }
      createFavourite();
    }
  }, [fetchFavoritesList])

  const clearAllFilter = () => {
    setSelectedCatogray("");
    setIbThemeFilter([]);
    setApThemeFilter([]);
    setAnecotasThemeFilter([]);
  }

  const handleDropdownClick = useCallback((value) => {
    setIsDropdownOpen(prev => ({
      type: value,
      open: prev.type !== value || !prev.open
    }));
  }, []);

  const dropDownHandler = (action, value) => {
    if (action === "category") {
      setSelectedCatogray(value?.title);
      handleDropdownClick("")
    }
    if (action === "ibThemeFitler") {
      setIbThemeFilter(prev => {
        if (prev.includes(value)) {
          return prev.filter(item => item !== value)
        }
        return [...prev, value]
      })
    } else if (action === "apThemeFilter") {
      setApThemeFilter(prev => {
        if (prev.includes(value)) {
          return prev.filter(item => item !== value)
        }
        return [...prev, value]
      })
    }
    else if (action === "anecotasThemeFilter") {
      setAnecotasThemeFilter(prev => {
        if (prev.includes(value)) {
          return prev.filter(item => item !== value)
        }
        return [...prev, value]
      })
    }

  }



  const getFilteredResult = (result) => {
    if(result?.length === 0 || result === undefined ){
      return;
    }
    const matchThemes = (dataThemes, filterThemes, filterBy) => {
      let themes;
      if (!dataThemes || dataThemes.length === 0 || filterThemes.length === 0) return false;
      if (filterBy === 'anécdotas_themes') {
        themes = dataThemes.toLowerCase().split(',,').map(theme => theme.trim());
      } else {
        themes = dataThemes?.toLowerCase().split(',').map(theme => theme.trim());
      }
      return filterThemes.some(filter =>
        themes.some(theme => theme.includes(filter.toLowerCase()))
      );
    };

    let filteredResults = [...result];

    if (searchQuery !== "" && searchQuery?.length > 0) {
      filteredResults = filterWithTextVideos(filteredResults, searchQuery);
    }

    if (selectedCategoray !== "") {
      if (selectedCategoray.toLowerCase() !== "all") {
        filteredResults = filteredResults.filter(data => 
          data.categorias?.toLowerCase().includes(selectedCategoray.toLowerCase())
        );
      }
    }

    if (anecotasThemeFilter.length > 0) {
      filteredResults = filteredResults.filter(data => 
        matchThemes(data.anécdotas_themes, anecotasThemeFilter, 'anécdotas_themes')
      );
    }

    if (ibThemeFilter.length > 0) {
      filteredResults = filteredResults.filter(data => 
        matchThemes(data.ib_themes, ibThemeFilter, 'ib_themes')
      );
    }

    if (apThemeFilter.length > 0) {
      filteredResults = filteredResults.filter(data => 
        matchThemes(data.ap_themes, apThemeFilter, 'ap_themes')
      );
    }

    // If no filters are active, return all results
    if (
      anecotasThemeFilter.length === 0 &&
      ibThemeFilter.length === 0 &&
      apThemeFilter.length === 0 &&
      (selectedCategoray.length === 0 || selectedCategoray.toLowerCase() === "all") &&
      searchQuery?.length === 0
    ) {
      return result;
    }

    return filteredResults;
  };

  const bookItems = useMemo(() => {
    const filterData = getFilteredResult(UNIT_PAGES);
    if (isSelectedFilter == "category") {
      return sortUnitsByNew(getFilteredResult(fetchFavoritesList?.videos));
    }
    else if (isSelectedFilter === "viewed") {
      const data = UNIT_PAGES.filter(item =>
        mostViewedLesson.some(viewItem => viewItem.id === item.id)
      ).map(item => {
        const viewItem = mostViewedLesson.find(view => view.id === item.id)
        return { ...item, viewed_video: viewItem ? viewItem.viewed_video : 0 };
      })
      return sortUnitsByNew(getFilteredResult(data)).sort((a, b) => b.viewed_video - a.viewed_video);
    }
    else if (isSelectedFilter === "used") {
      return getFilteredResult(mostUsedData);
    }

    if (filterData) {
      return sortUnitsByNew(filterData)
    }
  }, [UNIT_PAGES, mostUsedData, apThemeFilter, ibThemeFilter, anecotasThemeFilter, selectedCategoray, searchQuery])

  const fetchFavorites = async () => {
    const data = {
      user_id: currentUser?.id,
      type: 'informate-lesson'
    }
    const result = await dispatch(handleListFavouriteVideo(data));
    setFetchFavorites(result);
  }

  const handleFavouriteVideo = async (data) => {
    const isBookInFavorites = fetchFavoritesList?.videos?.some(video => video.id === data.id);
    const updatedVideos = isBookInFavorites
      ? fetchFavoritesList.videos.filter(video => video.id !== data.id)
      : [...(fetchFavoritesList?.videos || []), data];
    let updatedData;
    if (fetchFavoritesList?.id) {
      updatedData = {
        ...fetchFavoritesList,
        videos: updatedVideos,
      };
    } else {
      updatedData = {
        user_id: currentUser?.id,
        videos: updatedVideos,
        type: 'informate-lesson'
      };
    }
    setLoader(data?.id);
    setFetchFavorites(updatedData)
    // await dispatch(handleCreateFavouriteVideo(updatedData));
    setLoader('');
  }



  useEffect(() => {
    let unsubscribe = () => { };

    listenToMostViewed("informate").then(unsubscribeFunc => {
      unsubscribe = unsubscribeFunc;
    });

    return () => unsubscribe();
  }, []);

  const listenToMostViewed = (type) => {
    return new Promise((resolve) => {
      const collectionRef = collection(firestore, "most_viewed_video");
      const q = query(collectionRef, where("type", "==", type), orderBy("viewed_video", "desc"));

      const unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const viewData = [];
          querySnapshot.forEach((doc) => {
            viewData.push({ id: doc.id, ...doc.data() });
          });
          setMostViewedLesson(viewData);
        },
        (error) => {
          console.error("Error listening to session changes:", error);
        }
      );

      resolve(unsubscribe);
    });
  };

  const createViewedVideo = (id) => {
    const data = mostViewedLesson.find(data => data.id === id);
    const CreateNewView = {
      type: "informate",
      id: id,
      viewed_video: (data?.viewed_video || 0) + 1
    };
    createResourceViews(CreateNewView)
  };



  return (
  <SentryWrap>
    <Wrapper
      className="dashMenuCollect"
      onContextMenu={(e) => {
        e.preventDefault();
        showCopyRight();
      }}
    >
      {currentUser?.role == 'admin' ? <BackButtonEbook onClick={() => navigate('/ebook_list?key=informate')} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, minWidth: 100 }} /> : null}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}>
        <Alert onClose={handleClose} severity={alert.type}>
          <strong>ALERT:</strong> {alert.message}
        </Alert>
      </Snackbar>
      {loading ? (
        <CenterContainer>
          <Loading />
        </CenterContainer>
      ) : (
        <>
          <CategoryMenu
            className={`search-bar-resource lg-h-36px`}
            style={{ display: isMobile > 1100 ? "none" : "flex", border: "1px solid #ffffff", marginTop: "24px", paddingRight: 0, width: "160px" }}
          >
            <SearchInput
              style={{ width: "100%" }}
              className="search-input"
              type={"text"}
              placeholder="SEARCH"
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value) }}
            />
            <div className="dropdown-resource-arrow-container">
              <div
                style={{
                  transition: "transform 0.4s ease-in-out",
                }}
              >
                <img
                  // className="-mt-5px"
                  src={getFireBaseUrl("search-icon-placeholder.svg")}
                  alt=""
                />
              </div>
            </div>
            {/* <MenuIconImg src={SearchIcon} />{" "} */}
          </CategoryMenu>
          
          <div style={{ justifyContent: "center", marginTop: "20px", marginBottom: "20px" }} className="flex flex-wrap items-center gap-24px">
            <Row className="all-dropdown-mobile-view gap-24px lg-gap-20px md-wrap nowrap lg-gap-26px">

              <div className="md-w-full-2" style={{ position: "relative" }}>
                {/* start dropdown */}
                <DropdownMenu type={"category"} handleDropdownClick={handleDropdownClick} closeDropDown={() => handleDropdownClick("")} themeFilter={selectedCategoray} dropDownHandler={dropDownHandler} open={isDropdownOpen.type === "category" &&
                  isDropdownOpen?.open} data={CATEGORIAS} />
              </div>

              {/* mob ib dropdown */}
              {isMobile <= 768 && (
                <div className="md-w-full-2  md-d-block d-none" style={{ position: "relative" }}>
                  <DropdownMenu type={"ibtheme"} handleDropdownClick={handleDropdownClick}
                    closeDropDown={() => handleDropdownClick("")} themeFilter={ibThemeFilter} dropDownHandler={dropDownHandler} open={isDropdownOpen.type === "ibtheme" &&
                      isDropdownOpen?.open} data={IBTHEME} />
                </div>
              )}

              <div className="md-w-full-2" style={{ position: "relative" }}>
                <DropdownMenu type={"ANéCDOTAS THEMES"} handleDropdownClick={handleDropdownClick} closeDropDown={() => handleDropdownClick("")} themeFilter={anecotasThemeFilter} dropDownHandler={dropDownHandler} open={isDropdownOpen.type === "ANéCDOTAS THEMES" &&
                  isDropdownOpen?.open} data={AnecdotasThemes} isResizingWindow={isMobile}
                />
              </div>
              <div className="md-w-full-2" style={{ position: "relative" }}>
                <DropdownMenu type={"AP THEMES"} handleDropdownClick={handleDropdownClick} closeDropDown={() => handleDropdownClick("")} themeFilter={apThemeFilter} dropDownHandler={dropDownHandler} open={isDropdownOpen.type === "AP THEMES" &&
                  isDropdownOpen?.open} data={APTHEME} />
              </div>

              {/* laptop ib dropdown */}
              {isMobile >= 768 && (
                <div className="md-w-full-2 md-d-none d-block" style={{ position: "relative" }}>
                  <DropdownMenu type={"ibtheme"} handleDropdownClick={handleDropdownClick}
                    closeDropDown={() => handleDropdownClick("")} themeFilter={ibThemeFilter} dropDownHandler={dropDownHandler} open={isDropdownOpen.type === "ibtheme" &&
                      isDropdownOpen?.open} data={IBTHEME} />
                </div>
              )}

              <CategoryMenu style={{ width: "160px", position: "relative", paddingLeft: "19px" }} className={`story-search-laptop topStorySearch lg-h-36px`}>

                <SearchInput
                  style={{ width: "100%" }}
                  type={"text"} placeholder="SEARCH"
                  value={searchQuery}
                  onChange={(e) => { setSearchQuery(e.target.value) }}
                />
                <div className="dropdown-resource-arrow-container">
                  <div
                    style={{
                      transition: "transform 0.4s ease-in-out",
                    }}
                  >
                    <img
                      // className="-mt-5px"
                      src={getFireBaseUrl("search-icon-placeholder.svg")}
                      alt=""
                    />
                  </div>
                </div>
                {/* <MenuIconImg src={SearchIcon} /> */}
              </CategoryMenu>
              {/* End dropdown */}
            </Row>
            <Row style={{ margin: 0 }} className=" flex gap-28px lg-gap-19px boxes-parent lg-ml-0px nowrap">
              {isSelectedFilter === "category" ? (
                <div
                  onClick={(event) => {
                    event.stopPropagation();
                    clearAllFilter();
                    setIsSelectedFilter("");
                    // fetchVideoData()
                  }}
                  className="w-197px md-w-104px cursor-pointer justify-between h-43px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <div className="back-text-resource">Back</div>
                  <img
                    width={33}
                    src={BackIcon}
                    alt="heart"
                    className="w-30px h-25px md-h-20 md-w-18px"
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    clearAllFilter();
                    setIsSelectedFilter("category")
                    // setAllVideos(allFavorites?.videos||[])
                  }}
                  className="md-w-104px  h-43px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <img src={HeartIcon} alt="heart" className="mr-6px md-h-20 md-w-18px w-30px h-25px" />
                  <div className="my-library-font">MIS FAVORITOS</div>
                </div>
              )}
              {isSelectedFilter === "used" ? (
                <div
                  onClick={(event) => {
                    clearAllFilter();
                    event.stopPropagation();
                    setIsSelectedFilter("");
                  }}
                  className="w-197px  md-w-104px cursor-pointer justify-between h-43px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <div className="back-text-resource">Back</div>
                  <img
                    width={33}
                    src={BackIcon}
                    alt="heart"
                    className="w-30px h-25px md-h-20 md-w-18px"
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    clearAllFilter();
                    setIsSelectedFilter("used");
                  }}
                  className="md-h-20 md-w-18px md-w-104px h-45px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <img src={TaskIcon} alt="task" className="mr-6px md-h-20 md-w-18px w-30px h-25px" />
                  <div className="my-library-font">Más UTILIZADOS</div>
                </div>
              )}
              {isSelectedFilter === "viewed" ? (
                <div
                  onClick={(event) => {
                    clearAllFilter();
                    event.stopPropagation();
                    setIsSelectedFilter("");
                  }}
                  className="w-219px md-w-104px cursor-pointer justify-between h-45px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <div className="back-text-resource">Back</div>
                  <img
                    width={33}
                    src={BackIcon}
                    alt="heart"
                    className="w-30px h-25px md-h-20 md-w-18px"
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    clearAllFilter();
                    // fetchVideoData()
                    setIsSelectedFilter("viewed");
                  }}
                  className=" h-45px br-14px box-shadow-resource-hover flex items-center bg-gradient-pink cursor-pointer pr-16px pl-24px"
                >
                  <img
                    src={ChampionIcon}
                    alt="champion"
                    className="mr-6px md-h-20 md-w-18px w-30px h-25px"
                  />
                  <div className="my-library-font">
                    más VISTOS EN EL PAíS
                  </div>

                </div>
              )}
            </Row>
          </div>
          {/* <Row className="categoryBtns">
            <Dropdown className="categoryBtnOne" menu={categoryNav()} placement="bottomLeft">
              <CategoryMenu className="categorySmall">{selectedCategoray === '' || selectedCategoray === "All" ? "CATEGORIAS" : selectedCategoray}  <MenuIconImg src={MenuIcon} /> </CategoryMenu>
            </Dropdown>
            <CategoryMenu className="categoryBtnTwo">
              <SearchInput type={"text"} placeholder="SEARCH" 
              onChange={(e) => {searchUnits(e.target.value) }}
              onFocus={e => e.target.placeholder = ''}
              onBlur={e => e.target.placeholder = 'SEARCH'}
               />
              <MenuIconImg src={SearchIcon} /> </CategoryMenu>
          </Row> */}
          <Row style={{ paddingTop: "1%", paddingBottom: 0 }} className="TabLessionContainer">
            <Col xs={{ span: 24 }} lg={{ span: 10 }} className="ColForTabs">
              <ImageContainer
              >
                <Images src={UNIT_IMAGE} />
              </ImageContainer>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 14 }} className="informateSpace ColForTabs">
              <CoverSecion overflowItem={units&&units?.length > 12}>
                {bookItems?.length > 0 ? (
                  <>
                    {chunk(bookItems, 4).map((bookitem, i) => {
                      return (<BoxRow key={i + "bookrow"}> {bookitem.map((item, index) => {
                        return (
                          <Column key={index + i + "bookcol"}>
                            {get(item, "new", false) && <NewTag>New</NewTag>}
                            <RenderIfVisible 
                              defaultHeight={260}
                              visibleOffset={100}
                              placeholder={
                                <SkeletonPlaceholder>
                                  <CoverSkeleton active />
                                  <SkeletonFooter>
                                    <Skeleton.Input active size="small" style={{ width: '100%', minWidth: 'unset' }} />
                                  </SkeletonFooter>
                                </SkeletonPlaceholder>
                              }
                            >
                              <BalconCover handleClick={() => {
                                createViewedVideo(item?.id)
                                onPageClick(item, i, index)
                              }}
                                page="balcon"
                                loader={loader}
                                allFavorites={fetchFavoritesList?.videos}
                                handleFavouriteVideo={handleFavouriteVideo}
                                data={item}
                                show_thumbnail={true}
                              />
                            </RenderIfVisible>
                          </Column>
                        );
                      })}
                      </BoxRow>)
                    })}
                  </>
                ) : (
                  <EmptyImagePlaceholder />
                )}

              </CoverSecion>
            </Col>
          </Row>
        </>
      )}
    </Wrapper>
  </SentryWrap>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});

export default connect(mapStateToProps, null)(InformateEbook);
